module.exports = __webpack_public_path__ + "static/media/display04.9e4e3220.jpg";